import {
  TCreateItemCodeGroup,
  TPutItemCodeGroupMembers,
  TQueryCatalogItems,
  TQueryItemCodeGroup,
  TUpdateItemCodeGroup,
} from '@src/modules'

import { client, request } from './config'

export const getItemCodeGroups = (params: TQueryItemCodeGroup, token: string) =>
  request({ url: 'admin/item-code-group', method: 'GET', params }, { token })

export const createItemCodeGroup = (body: TCreateItemCodeGroup, token: string) =>
  request({ url: 'admin/item-code-group', method: 'POST', data: body }, { token })

export const getItemCodeGroupDetail = (id: number, token: string) =>
  request({ url: `admin/item-code-group/${id}`, method: 'GET' }, { token })

export const updateItemCodeGroup = (id: number, body: TUpdateItemCodeGroup, token: string) =>
  request({ url: `admin/item-code-group/${id}`, method: 'PUT', data: body }, { token })

// Bypasses request(): DELETE's 409 body carries `usedByPolicyVersions` alongside `message`,
// and request()'s onError only forwards `.message` + `.data.data`, dropping everything else.
export const deleteItemCodeGroup = async (id: number, token: string) => {
  client.defaults.headers.common.Authorization = `Bearer ${token}`
  try {
    const res = await client({ url: `admin/item-code-group/${id}`, method: 'DELETE' })
    return res.data
  } catch (error: any) {
    return Promise.reject({
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      ...(error?.response?.data ?? { message: error?.message }),
    })
  }
}

// Trọn danh sách 34 giá trị item.itemGroupCode — không phân trang, không tham số.
export const getCatalogItemGroups = (token: string) =>
  request({ url: 'admin/item-code-group/catalog-item-groups', method: 'GET' }, { token })

// Trọn danh sách ~250 giá trị item.colorCode — không phân trang. Nguồn đọc `item`, KHÔNG đọc
// bảng `color` (ADR-037 §2.3).
export const getCatalogColors = (search: string | undefined, token: string) =>
  request(
    { url: 'admin/item-code-group/catalog-colors', method: 'GET', params: { search } },
    { token },
  )

// 67.910 vật tư — trục duy nhất bắt buộc phân trang + tìm kiếm server-side.
export const getCatalogItems = (params: TQueryCatalogItems, token: string) =>
  request({ url: 'admin/item-code-group/catalog-items', method: 'GET', params }, { token })

// Trọn tập thành viên hiện tại — không phân trang, không tham số.
export const getItemCodeGroupMembers = (id: number, token: string) =>
  request({ url: `admin/item-code-group/${id}/members`, method: 'GET' }, { token })

// Ghi trọn tập thành viên (idempotent) — thay cho preview/commit/import/export của v1.0.
export const putItemCodeGroupMembers = (
  id: number,
  body: TPutItemCodeGroupMembers,
  token: string,
) => request({ url: `admin/item-code-group/${id}/members`, method: 'PUT', data: body }, { token })

// Chồng lấn mức sản phẩm (ADR-037 §4) — chỉ đường admin, không bao giờ gọi từ đường tính chiết
// khấu. `< 2` id thì gọi cũng vô hại (BE trả total:0 không chạy SQL) nhưng caller vẫn nên tự
// short-circuit để khỏi tốn 1 round-trip thừa.
export const getItemCodeGroupOverlaps = (groupIds: number[], token: string) =>
  request(
    { url: 'admin/item-code-group/overlaps', method: 'GET', params: { groupIds: groupIds.join(',') } },
    { token },
  )
